import user from "./user";
import test from "./test";
import resource from "./resource";
import answer from "./answer";
import participantData from "./participant-data";
import testSetups from "./testsetups";
import openAi from "./open-ai";

import store from "../store";
import router from "../routes";

import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.headers.get["Accept"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers.delete["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.delete["Content-Type"] = "application/json";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    // Only trigger on 401 (not already retried, and not on /refresh_token
    // or the /tokens sign-in endpoint — a failed login is not an expired session)
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/refresh_token") &&
      !originalRequest.url.endsWith("/tokens")
    ) {
      originalRequest._retry = true;

      try {
        // eslint-disable-next-line no-console
        console.warn("401 received — attempting refresh via /refresh_token");

        const res = await axios.post(`${process.env.VUE_APP_API}/refresh_token`, {}, {
          withCredentials: true,
        });

        const newToken = `Bearer ${res.data.access_token}`;

        // Store new token and update headers
        localStorage.setItem("bg-token", newToken);
        axios.defaults.headers.common["Authorization"] = newToken;
        originalRequest.headers["Authorization"] = newToken;

        // Retry the original request
        return axios(originalRequest);
      } catch (refreshError) {
        // eslint-disable-next-line no-console
        console.warn("🔒 Refresh token failed or expired — logging out");
        store.dispatch("logout");
        router.push("/signup");
        return Promise.reject(refreshError);
      }
    }

    // Optional: Handle server errors
    if (error.response && error.response.status === 500) {
      router.push("/500");
    }

    return Promise.reject(error);
  }
);



export default {
  user,
  test,
  participantData,
  testSetups,
  answer,
  resource,
  openAi,
};
